

export const sora = {
    tabs: { textToVideo: 'Text to Video', imageToVideo: 'Image to Video' },
    upload: { uploadImage: 'Upload Image', formats: 'JPG, PNG, WebP • Max 10MB' },
    prompt: {
      label: 'Prompt',
      placeholder: 'Describe the video you want to generate...',
      sub: 'Describe your desired video motion and content',
      count: '{count} / 5000'
    },
    model: { title: 'Model Version', sora2: 'Sora 2', sora2pro: 'Sora 2 Pro' },
    groups: { aspect: 'Aspect Ratio', duration: 'Duration' },
    options: { landscape: 'Landscape', portrait: 'Portrait', s10: '10s', s15: '15s' },
    toggle: { removeWatermark: 'Remove Watermark' },
    credits: { bar: 'Credits Cost', value: '{value} credits' },
    actions: { generate: 'Generate Video ({value} credits)' },
    preview: { title: 'Ready to Generate', desc: 'Enter your prompt and click generate to create amazing videos with Sora 2' }
  };
